// @ts-nocheck
import RequestAQuoteState from "@store/Framework/Store/Bunzl/Components/RequestAQuoteForm/RequestAQuoteState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: RequestAQuoteState = {
    isLoading: false,
};

const actions = {
    "Bunzl/Components/RequestAQuote/BeginLoading": (draft: Draft<RequestAQuoteState>) => {
        draft.isLoading = true;
    },
    "Bunzl/Components/RequestAQuote/FinishLoading": (draft: Draft<RequestAQuoteState>) => {
        draft.isLoading = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsRequestAQuoteFormActions = Parameters<typeof reducer>[1];
export default reducer;
